import { $, $$ } from 'utils/dom';
import { Modal } from '@3pc/modal-dialog';

const modal = $('.modal');

if (modal) {
  const modalOpenBtns = $$('[data-modal-open]');
  const timeOut = modal.getAttribute('data-timeout');

  const modalDialog = new Modal({
    modal, // modal element
    modalOpenBtns, // opens popup on click
    modalCloseBtns: $$('[data-modal-close]', modal), // closes popup on click
    isOpenOnInit: true, // opens popup on pageload ans saves it in session storage
    focusOut: $('#header-logo'), // element to focus on when popup is closed
  });

  setTimeout(() => {
    modalDialog.init();
  }, timeOut * 1000);
}
